import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'general-dialog-result',
  templateUrl: './general-dialog-result.component.html'
})
export class GeneralDialogResultComponent {
  public dialogHeader: string;
  public dialogText: string;
  public dialogType: string;
  public dialogList: Array<object>;
  public dialogImageClass: any;
  public dialogOptions: any;

  constructor(public dialogRef: MatDialogRef<GeneralDialogResultComponent>) {}

}
